import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    search: "",
};

export const projectSlice = createSlice({
    name: "project",
    initialState,
    reducers: {
        addSearchText: (state, action) => {
            state.search = action.payload;
        },
    },
});

export const { addSearchText } = projectSlice.actions;
export default projectSlice.reducer;
